import React from "react";
import { ChevronUp, FileText, Paperclip, Smile, Zap } from "lucide-react";

// AUTO-WA-39: the tools next to the message box — emoji, attach, quick
// replies and templates — in the Stage style.
function ComposerActions({ showAttachmentMenu, sending, onEmojiClick, onAttachmentClick, onTemplateClick, onQuickRepliesClick, quickRepliesOpen }) {
  return (
    <div className="wa-composer-tools">
      <button type="button" onClick={onEmojiClick} className="wa-tool" title="Emoji" aria-label="Emoji">
        <Smile size={18} />
      </button>
      <button type="button" onClick={onAttachmentClick} className={`wa-tool${showAttachmentMenu ? " is-on" : ""}`} title="Attach a photo, video or file" aria-label="Attach">
        {showAttachmentMenu ? <ChevronUp size={18} /> : <Paperclip size={18} />}
      </button>
      {onQuickRepliesClick && (
        <button type="button" onClick={onQuickRepliesClick} className={`wa-tool${quickRepliesOpen ? " is-on" : ""}`} title="Quick replies" aria-label="Quick replies" aria-expanded={quickRepliesOpen} disabled={sending}>
          <Zap size={18} />
        </button>
      )}
      <button type="button" disabled={sending} onClick={onTemplateClick} className="wa-tool wa-tool--text" title="Send an approved template">
        <FileText size={15} />
        <span className="wa-hide-sm">Template</span>
      </button>
    </div>
  );
}

export default ComposerActions;
